import { useRef, useEffect, useLayoutEffect, useState } from "react";
import { useIntersectionObserver } from "usehooks-ts";
import propTypes from "prop-types";
import BannerImage from "../bannerImage";
import MpuImage from "../mpuImage";

const Image = ({ mpu, onImageInView, rendering, rootMargin }) => {
  const imageRef = useRef(null);
  const [imageRefOnceLoaded, setImageRefOnceLoaded] = useState(null);
  const [imageViewCallbackFired, setImageViewCallbackFired] = useState(false);

  const { isIntersecting: isImageReadyToLoad = false } =
    useIntersectionObserver(imageRef, {
      freezeOnceVisible: true,
      threshold: 0,
      rootMargin: rootMargin || "300px"
    }) || {};

  const { isIntersecting: imageInView = false } =
    useIntersectionObserver(imageRefOnceLoaded, {
      freezeOnceVisible: true,
      threshold: 0.5
    }) || {};

  useEffect(() => {
    if (imageInView && !imageViewCallbackFired) {
      onImageInView();
      setImageViewCallbackFired(true);
    }
  }, [imageInView, onImageInView, imageViewCallbackFired]);

  useLayoutEffect(() => {
    if (isImageReadyToLoad) {
      setImageRefOnceLoaded(imageRef);
    }
  }, [isImageReadyToLoad]);

  const showWhenImageIsReadyToLoad = (content) =>
    isImageReadyToLoad ? content : undefined;

  if (mpu) {
    return (
      <MpuImage
        altText={showWhenImageIsReadyToLoad(rendering?.alt_text)}
        imageUrl={showWhenImageIsReadyToLoad(rendering?.background_image)}
        imageRef={imageRef}
      />
    );
  }
  return (
    <BannerImage
      altText={showWhenImageIsReadyToLoad(rendering?.alt_text)}
      largeImage={showWhenImageIsReadyToLoad(
        rendering?.background_image_billboard
      )}
      mediumImage={showWhenImageIsReadyToLoad(
        rendering?.background_image_leaderboard
      )}
      smallImage={showWhenImageIsReadyToLoad(
        rendering?.background_image_large_mobile_banner
      )}
      imageRef={imageRef}
    />
  );
};

Image.propTypes = {
  mpu: propTypes.bool,
  onImageInView: propTypes.func,
  rendering: propTypes.object,
  rootMargin: propTypes.string
};

export default Image;
